<template>
  <div class="ticon-waggon-component" :style="`width: ${icon_size}px; height: ${icon_size}px;`">
    <div class="waggon-grid" :style="`grid-template-columns: ${grid_columns}`">
      <div v-for="workpackage in workpackages" :key="`ticon-waggon-component-${waggon.id}${workpackage.id}`"
        :style="`background-color: ${getColor(workpackage.color)};width: ${workpackage_size}px; height: ${workpackage_size}px;`"> 
      </div>
    </div>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';

export default {
  props: [
    'waggon',
    'workpackages', // workpackage obj
    'size', // size in px
  ],

  mixins: [
    TColor
  ],
  components: {
  },
  data: () => ({
  }),

  computed: {
    icon_size() {
      if (this.size) {
        return this.size;
      }
      return 24;
    },
    workpackage_size(){
      let size = this.icon_size - 4;
      // if workpackages length is 1 then return size, if 2 or 3  then return size / 2 if 4 or 5 then return size / 4 if 6 or 7 then return size / 6
      if (this.workpackages.length === 1) {
        return size;
      } else if (this.workpackages.length === 2 || this.workpackages.length === 3) {
        return size / 2;
      } else if (this.workpackages.length === 4 || this.workpackages.length === 5) {
        return size / 4;
      } else if (this.workpackages.length === 6 || this.workpackages.length === 7) {
        return size / 6;
      }
      return size;
    },
    grid_columns() {
      if (this.workpackages.length) {
        let column_count = 2
        if (this.workpackages.length !== 2) {
          column_count = Math.ceil(this.workpackages.length / 2)
        }
        return `repeat(${column_count}, ${100 / column_count}%)`
      } else {
        return 'repeat(1, 100%)'
      }
    },
  },
}
</script>

<style>
.ticon-waggon-component {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #424242;
  border-radius: 4px;
}
.waggon-grid {
    display: grid;
  }
</style>
